import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby-plugin-intl"
import Img from "gatsby-image"
import { Box, SlideFade } from "@chakra-ui/react"
import slugify from "../utils/slugify"
import { calculateBuyPrice } from "../utils/calculatePrice"
import fallbackImg from "../img/fallback.jpg"

const BikeCard = ({ bike }) => {
  if (!bike) return null
  const image = bike?.images && bike?.images[0]
  const slug = slugify(bike.name)
  return (
    <div className="product-card" style={{ width: "100%" }}>
      <SlideFade in>
        <Link to={`/product/${slug}`} itemProp="url">
          <Box>
            {image.fluid ? (
              <Img
                fluid={image.fluid}
                alt=""
                style={{ borderRadius: "20px" }}
              />
            ) : (
              <img
                src={fallbackImg}
                style={{ maxHeight: "180px", borderRadius: "20px" }}
              />
            )}
          </Box>
          <Box marginTop="3">{bike.name}</Box>

          <Box opacity="0.6">{`kr ${
            bike.tags
              ? calculateBuyPrice(bike.prices.prices[0].price)
              : bike.prices.prices[0].price
          }${
            bike.prices?.prices?.length > 1
              ? " - " +
                calculateBuyPrice(
                  bike.prices?.prices[bike.prices.prices.length - 1].price
                )
              : ""
          }`}</Box>
        </Link>
      </SlideFade>
    </div>
  )
}

BikeCard.propTypes = {
  bike: PropTypes.object,
}

export default BikeCard
